import React from 'react'
import * as Styled from './SpotifyIntegrationStatus.styled'
import { Cancel, CheckCircle, Sync } from '@material-ui/icons'
import { Colors } from 'styles'
import { SpotifyPartnerStatus } from 'types'

interface IVariant {
  title: string
  icon: JSX.Element
  description?: JSX.Element
  text?: JSX.Element
}

const variants: Record<SpotifyPartnerStatus, IVariant> = {
  processing: {
    title: 'Processando',
    icon: <Sync fontSize="large" style={{ color: Colors.GREY[300] }} />,
    text: (
      <Styled.IntegrationInfoTextContainer>
        <Styled.IntegrationInfoText>
          A criação da sua página de conteúdos exclusivos no Spotify deve levar
          entre 30min e 1 hora.
        </Styled.IntegrationInfoText>
        <Styled.IntegrationInfoText>
          Mas o seu link já está pronto!
          <br />A partir dele, você pode acompanhar a publicação da sua página:
        </Styled.IntegrationInfoText>
      </Styled.IntegrationInfoTextContainer>
    ),
  },
  success: {
    title: 'Ativo',
    icon: (
      <CheckCircle fontSize="large" style={{ color: Colors.PURPLE[400] }} />
    ),
    text: (
      <Styled.IntegrationInfoTextContainer>
        <Styled.IntegrationInfoText>
          A sua página de conteúdos exclusivos no Spotify está pronta!
          <br />
          Use o link abaixo para acessar e também para compartilhar com seus
          apoiadores!
        </Styled.IntegrationInfoText>
      </Styled.IntegrationInfoTextContainer>
    ),
  },
  failed: {
    title: 'Falha',
    icon: <Cancel fontSize="large" style={{ color: Colors.SUPPORT_ERROR }} />,
    description: (
      <>
        Algo não correu como esperado. Entre em contato com o suporte{' '}
        <Styled.Url
          href="https://orelohelp.zendesk.com/hc/pt-br/requests/new"
          target="_blank"
          rel="noopener noreferrer"
        >
          aqui.
        </Styled.Url>
      </>
    ),
  },
  unknown: {
    title: 'Processando',
    icon: <Sync fontSize="large" style={{ color: Colors.GREY[300] }} />,
    text: (
      <Styled.IntegrationInfoTextContainer>
        <Styled.IntegrationInfoText>
          A criação da sua página de conteúdos exclusivos no Spotify deve levar
          entre 30min e 1 hora.
        </Styled.IntegrationInfoText>
        <Styled.IntegrationInfoText>
          Mas o seu link já está pronto!
          <br />A partir dele, você pode acompanhar a publicação da sua página:
        </Styled.IntegrationInfoText>
      </Styled.IntegrationInfoTextContainer>
    ),
  },
}

interface SpotifyIntegrationStatusProps {
  status: SpotifyPartnerStatus
}

const SpotifyIntegrationStatus: React.FC<SpotifyIntegrationStatusProps> = ({
  status,
}) => {
  const variant = variants[status]

  return (
    <Styled.Container>
      <Styled.TitleContainer>
        <Styled.Title>{variant.title}</Styled.Title>
        {variant.icon}
      </Styled.TitleContainer>

      {variant.description && (
        <Styled.Description>{variant.description}</Styled.Description>
      )}

      {variant.text}
    </Styled.Container>
  )
}

export default SpotifyIntegrationStatus
